import { platformBrowser } from '@angular/platform-browser'; 
import '@emorg-prd/standard-vanilla/js/em-standard.js';
import '@emorg-prd/standard-vanilla/js/vendor/inclusive-dates/inclusive-dates.js';

import { AppModule } from './app/app.module';


declare global {
  interface Window {
    pdfWorkerSrc?: string;
    ['pdfWorkerSrc4.8.69']?: string;
  }
}

window.pdfWorkerSrc = '/pdfjs/pdf.worker.min.mjs';
window['pdfWorkerSrc4.8.69'] = '/pdfjs/pdf.worker.min.mjs';

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));
